export default "__VITE_ASSET__COq5X94v__"